/**
 * Feature flags for ModCar application
 *
 * Use these to toggle features on/off without code changes.
 * Can be overridden via environment variables or runtime config.
 */

export const featureFlags = {
  /**
   * Show Quick Add menu in TopBar
   * Allows quick creation of Vehicles, Customers, and Invoices
   *
   * @default false
   */
  topbarQuickAdd: false,

  /**
   * Enable notification bell in TopBar
   * Requires backend notification system
   *
   * @default false
   */
  topbarNotifications: false,

  /**
   * Enable global command palette (Cmd/Ctrl+K)
   * Fast keyboard-driven search and navigation
   *
   * @default true
   */
  commandPalette: true,

  /**
   * Enable Microsoft OAuth login
   * Azure AD app registration now supports personal Microsoft accounts
   * (hotmail/outlook/live) via signInAudience: "AzureADandPersonalMicrosoftAccount"
   *
   * @default true
   */
  microsoftLogin: true,

  /**
   * Enable SnelStart accounting integration
   * When false, SnelStart is completely hidden from the UI:
   * - Settings → Accounting: no SnelStart card/option
   * - Provider pickers: SnelStart not listed
   * - Customer/supplier accounting tabs: no SnelStart section
   * - Export triggers: blocked with user-friendly message
   *
   * Exact Online and Twinfield remain fully functional.
   * Set to true to re-enable SnelStart.
   *
   * @default false
   */
  snelstart: false,
} as const;

/**
 * Check if a feature is enabled
 *
 * @example
 * if (isFeatureEnabled('topbarQuickAdd')) {
 *   // Show Quick Add menu
 * }
 */
export function isFeatureEnabled(feature: keyof typeof featureFlags): boolean {
  return featureFlags[feature];
}
